import React, { Component } from 'react'
import moment from 'moment'
import $ from 'jquery'
import { AppSettings, MessageText, Storage } from '../../configs'

import {
    SecureGateRoute,
    BreadCrumb,
    UserModal,
    SearchEmployeeModal
} from "../../components"
import {
    getUserDataAction,
    updateUserModalAction,
    deleteUserAction,
    clearErrorMsgAction,
    getAllUserAction,

} from '../../redux/actions/UserAction'
import { connect } from 'react-redux'
import { Div, Input, DatePicker, Select, TextArea } from "../../components/core";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from "@material-ui/core/TablePagination";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { msg } from '../../components/Notifications/MsgBox';
import '../../assets/css/rrs.css'
import { getAllOrgUnitsAction } from '../../redux/actions/MasterAction'
import UserServices from '../../services/UserServices';

class UserScreen extends Component {
    constructor(props) {
        super(props)

        this.state = {
            order_user: "asc",
            orderBy_user: "",
            page_user: 0,
            rowsPerPage_user: 10,
            filteruserDataArr: [],
            filter_username: '',
            filter_firstName: '',
            filter_lastName: '',
            filter_email: '',
            filter_unitCode: '',
            filter_isAdmin: '',
            filter_userGroup: '',
            filter_status: '',
            appReadonly: true
        }

        this.handleRequestSort = this.handleRequestSort.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.handleChangefilter = this.handleChangefilter.bind(this)
        this.setUserModal = this.setUserModal.bind(this)
        this.setDefaultPage = this.setDefaultPage.bind(this)
        this.loadDataUserAll = this.loadDataUserAll.bind(this)
        window.onSavePopupUser = this.loadDataUserAll.bind(this)
    }

    componentDidMount() {
        //this.props.getUserData()
        this.loadDataUserAll()
        this.handleApplicationCheckReadonly()

        $(function () {
            window.onComponentDidMount()
        })
    }

    async handleApplicationCheckReadonly()
    {
        UserServices.ApplicationReadonly().then(response=>{
            if(response.data === false)
            {
                this.setState({appReadonly: false})
            }
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.userData !== this.state.filteruserDataArr) {

            this.setState({
                filteruserDataArr: nextProps.userData
            })

        }
    }

    async loadDataUserAll() {
        const employeePIS = Storage.getEmployeePIS()
        await this.props.getAllUser(employeePIS.departmentCode)
        await this.props.getAllOrgUnits()
        this.filterdata()
    }

    setDefaultPage() {
        this.setState({
            page_user: 0
        })
    }

    setUserModal(index = "") {
        this.props.clearErrorMsg()
        let data = { index: index }
        this.props.updateUserModal(data)
        // console.log("setUserModal", data)
    }

    delUser(employeeID) {
        // this.props.deleteUser(employeeID)
        // msg.success("Delete User success")
        msg.showConfirm(
            "Confirm",
            MessageText.PAGE.USER.POPUP_MSG_CONFIRM_DELETE,
            () => {
                msg.hideConfirm()
                this.props.deleteUser(employeeID)
                msg.success(MessageText.PAGE.USER.POPUP_MSG_SUCCESS_DELETE)
            },
            () => {
                msg.hideConfirm()
                console.log("On Cancel")
            },
            () => {
                console.log("On Closed")
            }
        )
    }

    // Grid start

    desc(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    stableSort(array, cmp) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = cmp(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map(el => el[0]);
    }

    getSorting(order, orderBy) {
        return order === "desc"
            ? (a, b) => this.desc(a, b, orderBy)
            : (a, b) => -this.desc(a, b, orderBy);
    }

    handleRequestSort(event, property) {
        const isDesc = this.state.orderBy_user === property && this.state.order_user === "desc";
        this.setState({
            order_user: isDesc ? "asc" : "desc",
            orderBy_user: property
        })
    }

    handleChangePage(event, newPage) {
        this.setState({
            page_user: newPage
        })
    }

    handleChangeRowsPerPage(event) {
        this.setState({
            rowsPerPage_user: +event.target.value,
            page_user: 0
        })
    }

    // Grid end

    async handleChangefilter(event) {
        event.preventDefault()
        const { name, value } = event.target;

        await this.setState({ [name]: value })

        this.filterdata()
    }

    async filterdata() {
        
        let filteruserData = []
        filteruserData = this.props.userData

        const { filter_username, filter_firstName, filter_lastName, filter_email, filter_unitCode, filter_isAdmin, filter_userGroup, filter_status } = this.state

        if (filter_username) {
            filteruserData = filteruserData.filter((data) => {
                return data.userName && data.userName.toLowerCase().indexOf(filter_username.toLowerCase()) > -1
            })
        }
        if (filter_firstName) {
            filteruserData = filteruserData.filter((data) => {
                return data.firstName && data.firstName.toLowerCase().indexOf(filter_firstName.toLowerCase()) > -1
            })
        }
        if (filter_lastName) {
            filteruserData = filteruserData.filter((data) => {
                return data.lastName && data.lastName.toLowerCase().indexOf(filter_lastName.toLowerCase()) > -1
            })
        }
        if (filter_email) {
            filteruserData = filteruserData.filter((data) => {
                return data.email && data.email.toLowerCase().indexOf(filter_email) > -1
            })
        }
        if (filter_unitCode) {
            filteruserData = filteruserData.filter((data) => {
                return data.unitCode && (data.unitCode.indexOf(filter_unitCode) > -1 || data.unitSubName.indexOf(filter_unitCode) > -1)
                //return data.unitCode && data.unitCode.indexOf(filter_unitCode) > -1
            })
        }
        if (filter_userGroup) {
            if (filter_userGroup == 1) {
                filteruserData = filteruserData.filter((data) => {
                    return data.userGroup == "Creator"
                })
            }
            if (filter_userGroup == 2) {
                filteruserData = filteruserData.filter((data) => {
                    return data.userGroup == "Reviewer"
                })
            }
        }
        if (filter_isAdmin) {
            if (filter_isAdmin == 1) {
                filteruserData = filteruserData.filter((data) => {
                    return data.isAdmin == true
                })
            }
            if (filter_isAdmin == 2) {
                filteruserData = filteruserData.filter((data) => {
                    return data.isAdmin == false
                })
            }
        }
        if (filter_status) {
            if (filter_status == 1) {
                filteruserData = filteruserData.filter((data) => {
                    return data.isActive == true
                })
            }
            if (filter_status == 2) {
                filteruserData = filteruserData.filter((data) => {
                    return data.isActive == false
                })
            }
        }

        await this.setState({ filteruserDataArr: filteruserData })
        this.setDefaultPage()
    }

    render() {
        const { userData, org_unit } = this.props
        const { filter_username, filter_firstName, filter_lastName, filter_email, filter_unitCode, filter_userGroup, filter_status, filteruserDataArr, appReadonly } = this.state
        const roleAdmin = Storage.getRoleAdmin()
        return (
            <div className="rrs">
                <SecureGateRoute />
                <div id="main-content">
                    <div className="page-body">
                        <BreadCrumb breadcrumb={[
                            { name: 'RRS Home', url: AppSettings.defaultUrl },
                            { name: 'User Management', url: '' }
                        ]}></BreadCrumb>
                        <div className="sp-page-header-panel row">
                            <div className="col-md-5 sp-page-header">
                                <h1 className="sp-page-header1">User Management</h1>
                            </div>
                        </div>
                        <div className="sp-page-result-container" style={{ marginTop: 18 }} id="user" >
                            <div className="sp-table-container">
                                <div className="row rrs-table-hdr-wrap">
                                    {/* <div className="col-md-2">
                                        <h2 className="rrs-table-hdr">ผู้ใช้งานระบบ</h2>
                                    </div> */}
                                </div>
                                { roleAdmin && !appReadonly && (
                                    <div className="row sp-pagination-control-top">
                                        <div className="col-auto create-button" >
                                            <a href="#" className="sp-bt-addmore" onClick={() => this.setUserModal()} data-toggle="modal" data-target="#userModal">
                                                <i className="icon btn-plus" />
                                                <span>เพิ่ม</span>
                                            </a>
                                        </div>
                                    </div>
                                )}
                                <div className="row no-gutters sp-table-content">

                                    <Table aria-labelledby="tableTitle" className="sp-table table rrs-table">
                                        <TableHead>
                                            <TableRow className="sp-table-header">
                                                <TableCell className="th-table text-center" style={{ width: '100px', maxWidth: '100px' }}>Username</TableCell>
                                                <TableCell className="th-table text-center" style={{ width: '100px', maxWidth: '100px' }}>ชื่อ</TableCell>
                                                <TableCell className="th-table text-center" style={{ width: '100px', maxWidth: '100px' }}>นามสกุล</TableCell>
                                                <TableCell className="th-table text-center" style={{ width: '200px', maxWidth: '200px' }}>E-mail</TableCell>
                                                <TableCell className="th-table text-center" style={{ width: '150px', maxWidth: '150px' }}>หน่วยงานผู้สร้าง</TableCell>
                                                <TableCell className="th-table text-center" style={{ width: '120px', maxWidth: '120px' }}>ประเภทผู้ใช้</TableCell>
                                                {/* <TableCell className="th-table text-center" style={{ width: '120px', maxWidth: '120px' }}>Role</TableCell> */}
                                                <TableCell className="th-table text-center" style={{ width: '120px', maxWidth: '120px' }}>สถานะ</TableCell>
                                                { !appReadonly && <TableCell className="th-table text-center" style={{ width: '80px', maxWidth: '80px' }}>รายละเอียด</TableCell>}
                                            </TableRow>
                                            <TableRow className="sp-table-filter">
                                                <TableCell><input type="text" name="filter_username" className="form-control" onChange={this.handleChangefilter} value={filter_username} /></TableCell>
                                                <TableCell><input type="text" name="filter_firstName" className="form-control" onChange={this.handleChangefilter} value={filter_firstName} /></TableCell>
                                                <TableCell><input type="text" name="filter_lastName" className="form-control" onChange={this.handleChangefilter} value={filter_lastName} /></TableCell>
                                                <TableCell><input type="text" name="filter_email" className="form-control" onChange={this.handleChangefilter} value={filter_email} /></TableCell>
                                                <TableCell><input type="text" name="filter_unitCode" className="form-control" onChange={this.handleChangefilter} value={filter_unitCode} /></TableCell>
                                                <TableCell>
                                                    <Select
                                                        name="filter_userGroup"
                                                        value={filter_userGroup}
                                                        onChange={this.handleChangefilter}
                                                    >
                                                        <option
                                                            key={0}
                                                            value={0}>
                                                            {"เลือกทั้งหมด"}
                                                        </option>
                                                        <option
                                                            key={1}
                                                            value={1}>
                                                            {"Creator"}
                                                        </option>
                                                        <option
                                                            key={2}
                                                            value={2}>
                                                            {"Reviewer"}
                                                        </option>
                                                    </Select>
                                                </TableCell>
                                                {/* <TableCell>
                                                    <Select
                                                        name="filter_isAdmin"
                                                        value={filter_isAdmin}
                                                        onChange={this.handleChangefilter}
                                                    >
                                                        <option
                                                            key={0}
                                                            value={0}>
                                                            {"เลือกทั้งหมด"}
                                                        </option>
                                                        <option
                                                            key={1}
                                                            value={1}>
                                                            {"Admin"}
                                                        </option>
                                                        <option
                                                            key={2}
                                                            value={2}>
                                                            {"User"}
                                                        </option>
                                                    </Select>
                                                </TableCell> */}
                                                <TableCell>
                                                    <Select
                                                        name="filter_status"
                                                        value={filter_status}
                                                        onChange={this.handleChangefilter}
                                                    >
                                                        <option
                                                            key={0}
                                                            value={0}>
                                                            {"เลือกทั้งหมด"}
                                                        </option>
                                                        <option
                                                            key={1}
                                                            value={1}>
                                                            {"ใช้งาน"}
                                                        </option>
                                                        <option
                                                            key={2}
                                                            value={2}>
                                                            {"ไม่ใช้งาน"}
                                                        </option>
                                                    </Select>
                                                </TableCell>
                                                { !appReadonly && <TableCell></TableCell>}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {Array.isArray(filteruserDataArr) && (this.stableSort(filteruserDataArr, this.getSorting(this.state.order_user, this.state.orderBy_user))
                                                .slice(this.state.page_user * this.state.rowsPerPage_user, this.state.page_user * this.state.rowsPerPage_user + this.state.rowsPerPage_user)
                                                .map((row, index) => {
                                                    let index_start = userData.findIndex(f => f.userId == row.userId)

                                                    let _unittext = ''
                                                    let objunit = org_unit.find(f => f.unitcode == row.unitCode)
                                                    if (objunit) {
                                                        _unittext = objunit.unitcode + ' : ' + objunit.unitabbr
                                                    }

                                                    return (
                                                        <TableRow
                                                            hover
                                                            tabIndex={-1}
                                                            key={index}
                                                        >
                                                            <TableCell><label className="label-full text-grid">{row.userName}</label></TableCell>
                                                            <TableCell><label className="label-full text-grid">{row.firstName}</label></TableCell>
                                                            <TableCell><label className="label-full text-grid">{row.lastName}</label></TableCell>
                                                            <TableCell><label className="label-full text-grid">{row.email}</label></TableCell>
                                                            <TableCell><label className="label-full text-grid">{row.unitCode + ' : ' + row.unitSubName}</label></TableCell>
                                                            <TableCell className="text-center"><label className="label-full text-grid">{row.userGroup}</label></TableCell>
                                                            {/* <TableCell className="text-center">
                                                                <label className={"label-full text-grid "}>
                                                                    {row.isAdmin ? "Admin" : "User"}
                                                                </label>
                                                            </TableCell> */}
                                                            <TableCell className="text-center">
                                                                <label className={"label-full text-grid "}>
                                                                    {row.isActive ? "ใช้งาน" : "ไม่ใช้งาน"}
                                                                </label>
                                                            </TableCell>
                                                            { !appReadonly && <TableCell className="action-icon">
                                                                <a href="#" onClick={() => this.setUserModal(index_start)} data-toggle="modal" data-target="#userModal">
                                                                    <i className="icon bt-edit" />
                                                                </a>
                                                            </TableCell>}
                                                        </TableRow>
                                                    );

                                                }))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        className="pager"
                                        rowsPerPageOptions={[10, 25, 50, 100]}
                                        component="div"
                                        count={filteruserDataArr ? filteruserDataArr.length : 0}
                                        rowsPerPage={this.state.rowsPerPage_user}
                                        page={this.state.page_user}
                                        backIconButtonProps={{
                                            "aria-label": "previous page"
                                        }}
                                        nextIconButtonProps={{
                                            "aria-label": "next page"
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <UserModal />
                <SearchEmployeeModal />
                {/* backtotop button */}
                <div className="backtotop-panel">
                    <span className="bt-backtotop btn">
                        <i className="icon btn-order-top" onClick={() => window.scroll({ top: 0, behavior: 'smooth' })} />
                    </span>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { AppRedux, UserRedux, MasterRedux } = state
    return {
        userData: UserRedux.userData,
        tagErrors: AppRedux.tagErrors,
        errorMsg: UserRedux.errorMsg,
        org_unit: MasterRedux.org_unit,
    }
}

const mapDispatchToProps = dispatch => {
    return {

        getUserData: () => dispatch(getUserDataAction()),
        updateUserModal: (data) => dispatch(updateUserModalAction(data)),
        deleteUser: (data) => dispatch(deleteUserAction(data)),
        clearErrorMsg: () => dispatch(clearErrorMsgAction()),
        getAllUser: (data) => dispatch(getAllUserAction(data)),
        getAllOrgUnits: () => dispatch(getAllOrgUnitsAction()),

    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserScreen);